import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type FlaggedPhoneNumber } from 'types/api'
import { useMutation } from '@tanstack/react-query'
import { isNil } from 'lodash'

interface UsePutFlaggedPhoneNumberProps {
  onSuccess?: (
    data: boolean,
    variables: FlaggedPhoneNumber
  ) => void | Promise<void>
  onError?: (error: Error, variables: FlaggedPhoneNumber) => void
}

export const usePutFlaggedPhoneNumber = ({
  onSuccess,
  onError,
}: UsePutFlaggedPhoneNumberProps) => {
  const put = useTypedApiClient({
    path: '/admin/flaggedPhoneNumbers/{id}',
    method: 'put',
  })

  return useMutation<boolean, Error, FlaggedPhoneNumber>({
    mutationFn: async (data: FlaggedPhoneNumber) => {
      const id = data.id
      if (isNil(id)) {
        throw Error('Id is null')
      }
      const response = await put({ ...data, id })
      return response.data
    },
    onSuccess: async (data, variables) => {
      await onSuccess?.(data, variables)
    },
    onError,
  })
}
